import { render, staticRenderFns } from "./EncountersReferral.vue?vue&type=template&id=f22bb752&"
import script from "./EncountersReferral.vue?vue&type=script&lang=js&"
export * from "./EncountersReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports